import { createContractRequest } from './helper';
export const putChangesWorkflow = createContractRequest({
    route: '/contract/contract/:policyNo/changes/:changeId',
    method: 'put',
    source: 'data',
    responseCode: 200,
});
